class Base {
}

export default Base;
